// extracted by mini-css-extract-plugin
module.exports = {"faqBack":"FaqBreadcrumb_faqBack__HoV2k","breadcrumContainer":"FaqBreadcrumb_breadcrumContainer__n2ltd","arrowLeft":"FaqBreadcrumb_arrowLeft__B5rgU"};